<template>
  <section id="about">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading">Getting started</h2>
          <h3 class="section-subheading text-muted">Watch videos from your friends in 6 easy steps !</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <ul class="timeline">
            <li>
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="../../assets/img/about/step-1-thumbnail.png" alt="">
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>Step 1</h4>
                  <h4 class="subheading">Get your ID</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">Open the app and click on "Copy" in the upper right corner.</p>
                </div>
              </div>
            </li>
            <li class="timeline-inverted">
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="../../assets/img/about/step-2-thumbnail.png" alt="">
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>Step 2</h4>
                  <h4 class="subheading">Share your ID</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">Share the ID you just copied with a friend who want to watch your videos.</p>
                </div>
              </div>
            </li>
            <li>
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="../../assets/img/about/step-3-thumbnail.png" alt="">
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>Step 3</h4>
                  <h4 class="subheading">Connect</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">Enter your friend's ID in the "Remote" tab.</p>
                </div>
              </div>
            </li>
            <li class="timeline-inverted">
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="../../assets/img/about/step-4-thumbnail.png" alt="">
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>Step 4</h4>
                  <h4 class="subheading">Choose your video</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">Choose a video from your friend's collection in the "Collections" panel.</p>
                </div>
              </div>
            </li>
            <li>
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="../../assets/img/about/step-5-thumbnail.png" alt="">
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>Step 5</h4>
                  <h4 class="subheading">Wait a short time</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">Your friend is automatically preparing the video for you before streaming it.</p>
                </div>
              </div>
            </li>
            <li class="timeline-inverted">
              <div class="timeline-image">
                <h4>Step 6<br>Enjoy<br>Your video</h4>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'about'
  }
</script>



// WEBPACK FOOTER //
// About.vue?50a39093